/**
 * 飞书（Lark）环境识别与免登授权地址构建。
 * 统一落在**认证中心**的登录页，由认证中心拿 code 换取用户身份后，再带着 ssoToken 回跳本系统的 /login
 * 登录页」时换成飞书授权地址，其余流程（回跳取 ssoToken、校验、跳回原页面）
 */

const SSO_URL = process.env.REACT_APP_SSO_URL || '';

/**
 * 飞书企业自建应用的 App ID。
 * 与认证中心共用同一个应用：飞书授权回调地址指向认证中心域名，
 * 该地址已在飞书后台的重定向 URL 白名单里，因此这里沿用同一个 App ID，
 */
export const FEISHU_APP_ID = 'cli_aaa0381aff78dbc1';

/** 飞书 OAuth 授权端点 */
const FEISHU_AUTHORIZE_URL = 'https://open.feishu.cn/open-apis/authen/v1/authorize';

/**
 * 判断当前是否运行在飞书客户端内。
 * 双重检测：飞书 JS SDK 已挂载，或 UA 含飞书标识。
 * 以 UA 为主——SDK 是异步加载的，只看 h5sdk 会因时序问题误判为「不在飞书里」，
 * 那样用户在飞书里会被丢到需要账号密码的认证中心登录页。
 */
export const isFeishuEnv = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = (navigator.userAgent || '').toLowerCase();
  return !!(typeof window !== 'undefined' && window.h5sdk)
    || ua.indexOf('lark') > -1
    || ua.indexOf('feishu') > -1;
};

/** 认证中心是否已配置；未配置时飞书授权无意义（回调地址拼不出来） */
export const isFeishuConfigured = () => !!SSO_URL;

/**
 * 构建飞书授权地址。
 * @param {string} backUrl 授权完成后希望回到的本系统地址，通常就是 `${origin}/login`
 * @returns {string} 飞书授权页地址；认证中心地址未配置时返回空串
 */
export const buildFeishuOAuthUrl = (backUrl) => {
  if (!isFeishuConfigured()) return '';
  const redirectUri = `${SSO_URL}/login?loginSuccessBackUrl=${encodeURIComponent(backUrl)}`;
  const params = new URLSearchParams({
    app_id: FEISHU_APP_ID,
    redirect_uri: redirectUri,
    response_type: 'code',
    // 认证中心据此区分是飞书授权回调
    state: 'feishu'
  });
  return `${FEISHU_AUTHORIZE_URL}?${params.toString()}`;
};
